import { useState } from 'react'

/**
 * The «هزینه اشتراک» label with a small (i) that says whose money it is.
 *
 * On every payment summary the commission sits one line under the amount the
 * member is depositing, in the same column, in the same units — so it reads as
 * part of what the fund receives. It is not: it is Hamyan's fee, and neither
 * the fund nor its manager ever sees it. Members have gone to their managers
 * asking where it went, which is a question the screen should answer itself.
 *
 * Tap-to-disclose rather than hover: these screens are phone-first, and a
 * hover-only tooltip is invisible on touch.
 */
export default function CommissionHint({
    label = 'هزینه اشتراک',
    className = '',
}: {
    label?: string
    className?: string
}) {
    const [open, setOpen] = useState(false)

    return (
        <div className={`min-w-0 ${className}`}>
            <button
                type="button"
                onClick={() => setOpen(!open)}
                aria-expanded={open}
                aria-label={`${label} چیست؟`}
                className=" flex items-center gap-1 text-right"
            >
                <span>{label}</span>
                <span
                    aria-hidden
                    className=" inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full border border-text-secondary text-[10px] font-bold leading-none text-text-secondary"
                >
                    i
                </span>
            </button>
            {open && (
                <p className=" mt-1 text-[11px] leading-5 text-text-secondary">
                    هزینهٔ اشتراک بابت خدمات همیان است و به صندوق یا مدیر آن
                    نمی‌رسد.
                </p>
            )}
        </div>
    )
}
